import { render, staticRenderFns } from "./landing-link.vue?vue&type=template&id=65fbdfe6&"
import script from "./landing-link.vue?vue&type=script&lang=ts&"
export * from "./landing-link.vue?vue&type=script&lang=ts&"
import style0 from "./landing-link.vue?vue&type=style&index=0&id=65fbdfe6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports